import { Controller } from "stimulus"
import AppointmentService from "../../entrypoints/src/admin/services/appointment-service";
import AjaxLoader from '../../entrypoints/src/admin/utilities/ajax-loader';

export default class extends Controller {
  initializeMeeting(options = {}) {
    return new Promise((resolve, reject) => {
      this.meetRoomOptions = {
        roomName: this.roomNameValue,
        height: '100%',
        parentNode: document.querySelector(this.roomScreenValue),
        jwt: this.tokenValue
      };

      if (Traus.company.user.role === 'student') {
        // Explicitly ENABLE the prejoin page for the student. The moderator enables
        // the Jitsi lobby (toggleLobby) once the class starts, so the room becomes
        // members-only and the student's direct join is rejected with
        // `conference.connectionError.membersOnly`. The lobby "knock / waiting to be
        // admitted" screen is rendered as part of the prejoin flow — if prejoin is
        // off (whether via a client override or the server default) the student is
        // left with a blank screen instead of the waiting screen. Relying on the
        // server default is not safe here: the professor joins as `owner` and never
        // hits the lobby, so his session tells us nothing about the student's default.
        // Both keys are set for version safety (`prejoinConfig.enabled` is the modern
        // key; `prejoinPageEnabled` is the legacy one this build honors).
        this.meetRoomOptions['configOverwrite'] = {
          prejoinConfig: { enabled: true },
          prejoinPageEnabled: true,
          disableDeepLinking: true,
          disableInviteFunctions: true,
          enableWelcomePage: false,
          startWithAudioMuted: true,
          // The mobile classroom renders its own dock (mic / cam / hand / leave)
          // around the iframe. Hide Jitsi's native in-call toolbar for the student
          // so it stops overlapping that dock on mobile — the student drives the
          // call entirely through the custom dock, never the native toolbar.
          toolbarButtons: []
        };
      }

      Object.assign(this.meetRoomOptions, options);

      // Keep Jitsi's native toolbar/options on the stage. The redesigned dock adds
      // controls AROUND the iframe but must NOT replace the native ones — the
      // moderator needs Jitsi's participants pane / lobby prompts to admit students.

      try {
        let interval = setInterval(() => {
          if (!!JitsiMeetExternalAPI) {
            this.newMeet();
            resolve(this.api);
            clearInterval(interval);
          }
        }, 250);
      } catch (ex) {
        reject(ex);
      }
    });
  }

  // Stimulus action
  async newMeet() {
    AjaxLoader.show();
    this.api = new JitsiMeetExternalAPI(this.domainValue, this.meetRoomOptions);
    // NOTE: CustomEvent only preserves the `detail` field — passing `{ api }` directly
    // is silently dropped. The dock/meet listeners read `event.detail.api`.
    this.element.dispatchEvent(new CustomEvent('jitsi:start', { detail: { api: this.api } }));
    this.incomingMessage(this.api);
    this.element.querySelector('#loading-classroom-message').remove();
    AjaxLoader.hide();
  }

  toggleFullscreen() {
    this.element.classList.toggle('full-screen');
  }

  incomingMessage(jitsiApi) {
    jitsiApi.addEventListener('incomingMessage', (event) => {
      console.log('incomingMessage ...');
      console.log({ event });
      AppointmentService.postMeetingMessage(this.element.dataset.appointment, {
        message: event.message,
        from: event.nick
      })
    });
  }
}
